// src/components/HeaderSection.jsx
import React from 'react';

export default function HeaderSection({ handle, bio, showBio }) {
  return (
    <div className="container">
      <div className="row">
        <div className="col canario-cabecalho" style={{ paddingTop: 230 }}>
          {handle && <h1 style={{ textAlign: 'center' }}>{handle}</h1>}
          {showBio && bio && (
            <p style={{ marginTop: 16, textAlign: 'center' }}>{bio}</p>
          )}
        </div>
      </div>
    </div>
  );
}
